import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft, faChevronDown } from "@fortawesome/free-solid-svg-icons";

// Small button + menu for looking back at the Team of the Week of finished gameweeks.
// `pastWeeks` is [{gameweek, points}] newest first; `viewing` is the past gameweek on
// screen, or null while showing the upcoming one.
const TOTWHistoryMenu = ({ pastWeeks, viewing, upcomingGameweek, onSelect }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const close = (e) => {
            if (e.type === "keydown" ? e.key === "Escape" : !rootRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", close);
        document.addEventListener("touchstart", close);
        document.addEventListener("keydown", close);
        return () => {
            document.removeEventListener("mousedown", close);
            document.removeEventListener("touchstart", close);
            document.removeEventListener("keydown", close);
        };
    }, [open]);

    if (pastWeeks.length === 0) return <div></div>;

    const choose = (gameweek) => {
        onSelect(gameweek);
        setOpen(false);
    };

    return (
        <div className="totw-history" ref={rootRef}>
            <button
                type="button"
                className={`totw-history-button ${viewing !== null ? "viewing" : ""}`}
                aria-haspopup="menu"
                aria-expanded={open}
                aria-label={viewing !== null ? `Showing GW${viewing}, pick another week` : "Previous Teams of the Week"}
                title="Previous Teams of the Week"
                onClick={() => setOpen(o => !o)}
            >
                <FontAwesomeIcon icon={faClockRotateLeft} style={{fontSize: 11}}/>
                {viewing !== null && <span>GW{viewing}</span>}
                {viewing !== null && <FontAwesomeIcon icon={faChevronDown} style={{fontSize: 9}}/>}
            </button>
            {open && (
                <div className="totw-history-menu" role="menu">
                    <div className="totw-history-heading">Previous weeks</div>
                    {viewing !== null && (
                        <button type="button" role="menuitem" className="totw-history-item back"
                                onClick={() => choose(null)}>
                            <span>GW{upcomingGameweek}</span>
                            <span className="totw-history-points">upcoming</span>
                        </button>
                    )}
                    <div className="totw-history-list">
                        {pastWeeks.map(({ gameweek, points }) => (
                            <button type="button" role="menuitem" key={gameweek}
                                    className={`totw-history-item ${gameweek === viewing ? "active" : ""}`}
                                    onClick={() => choose(gameweek)}>
                                <span>GW{gameweek}</span>
                                <span className="totw-history-points">{points} pts</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TOTWHistoryMenu;
